import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=225bad76&scoped=true&"
import script from "./TitleBox.vue?vue&type=script&lang=js&"
export * from "./TitleBox.vue?vue&type=script&lang=js&"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=225bad76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bad76",
  null
  
)

export default component.exports